/* global FB */
export const login = () =>
  new Promise((resolve, reject) => {
    FB.login(
      res => {
        if (res.authResponse) {
          resolve({ token: res.authResponse.accessToken })
        } else {
          reject(res)
        }
      },
      { scope: 'email,user_location' }
    )
  })

export const getUserDetails = () =>
  new Promise((resolve, reject) => {
    FB.api(
      '/me',
      {
        fields: [
          'first_name',
          'last_name',
          'email',
          'location.fields(location)',
        ],
      },
      res => {
        if (res && !res.error) {
          resolve(res)
        } else {
          reject(res)
        }
      }
    )
  })
